import axiosInstance from './axiosInstance';

const BASE_URL = process.env.REACT_APP_API_URL;

export const GetAllEmployees = async () => {
  try {
    const { data } = await axiosInstance.get(`/employee/list`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const CheckEmpNameExist = async (name) => {
  try {
    //console.log("CheckAccNameExist");
    const { data } = await axiosInstance.post(
      `${BASE_URL}/employee/CheckEmpNameExist`,
      {
        name: name,
      },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllEmployeesByStore = async (store_id) => {
  try {
    //console.log("GetAllAccounts");
    const { data } = await axiosInstance.post(
      `${BASE_URL}/employee/getAllEmployeesByStore`,
      {
        store_id: store_id,
      },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetEmployeeById = async (employee_id) => {
  try {
    //console.log("GetEmployeeById");
    const { data } = await axiosInstance.post(
      `${BASE_URL}/employee/getEmployeeByID`,
      {
        employee_id: employee_id,
      },
    );
    //console.log(response.data);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const DeleteEmp = async (employee_id) => {
  try {
    //console.log("DeleteEmp");
    // console.log(names);
    const { data } = await axiosInstance.post(
      `${BASE_URL}/employee/DeleteEmp`,
      {
        employee_id: employee_id,
      },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const AddEmployeeApi = async (
  name,
  email,
  contact,
  hire_date,
  manager_id,
  salary,
  store_id,
  street_address,
  city,
  state,
  postal_code,
  acc_type_id,
  acc_notes,
  opening_balance
) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/employee/addEmployee`,
      {
        name: name,
        email: email,
        contact: contact,
        hire_date: hire_date,
        manager_id: manager_id,
        salary: salary,
        store_id: store_id,
        street_address: street_address,
        city: city,
        state: state,
        postal_code: postal_code,
        acc_type_id: acc_type_id,
        acc_notes: acc_notes,
        opening_balance: opening_balance,
      },
    );
    //console.log(response.data);
    return data;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const EditEmployeeApi = async (
  employee_id,
  name,
  email,
  contact,
  hire_date,
  manager_id,
  salary,
  location_id,
  store_id,
  street_address,
  city,
  state,
  postal_code,
  account_id,
  acc_type_id,
  acc_notes,
  opening_balance,
  ledger_type_id
) => {
  try {
    const { data } = await axiosInstance.put(
      `${BASE_URL}/employee/editEmployee`,
      {
        employee_id: employee_id,
        name: name,
        email: email,
        contact: contact,
        hire_date: hire_date,
        manager_id: manager_id,
        salary: salary,
        location_id: location_id,
        store_id: store_id,
        street_address: street_address,
        city: city,
        state: state,
        postal_code: postal_code,
        account_id: account_id,
        acc_type_id: acc_type_id,
        acc_notes: acc_notes,
        opening_balance: opening_balance,
        ledger_type_id: ledger_type_id,
      },
    );
    //console.log(response.data);
    return data;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export const GetAllEmpNameNoUsers = async (p_user_id) => {
  try {
    //console.log("GetAllPurchaseByID");
    const { data } = await axiosInstance.post(
      `${BASE_URL}/user/getAllEmpNameNoUsers`,
      {
        p_user_id: p_user_id,
      },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetAllManagers = async () => {
  try {
    //console.log("GetAllManagers");
    const { data } = await axiosInstance.post(
      `${BASE_URL}/employee/getAllManagers`,
      {},
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getAllManagersByID = async (employee_id) => {
  try {
    //console.log("getAllManagersByID");
    const { data } = await axiosInstance.post(
      `${BASE_URL}/employee/getAllManagersByID`,
      {
        employee_id: employee_id,
      },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetEmployeeLedgerLast = async (employee_id) => {
  try {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/employee/getEmployeeLedgerLast`,
      { employee_id: employee_id },
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
